import { Modal, ModalContent, ModalFooter, ModalHeader, RegularButton } from 'fronton-react';
import React, { useEffect, useState } from 'react';
import { B2BOrganization } from 'types/b2b-organization';
import { List } from './list';
import { useTranslation } from 'react-i18next';
import { WideButtonClassName } from './style';

type ChangeOrganizationPopupProps = {
  visible: boolean;
  list: B2BOrganization[];
  currentOrganizationNumber: string;
  isMobileView?: boolean;

  onApplyClick: (organizationNumber: string) => void;
  onClose: () => void;
};

export const ChangeOrganizationPopup = (props: ChangeOrganizationPopupProps) => {
  const { t } = useTranslation();
  const [currentNumber, setCurrentNumber] = useState(props.currentOrganizationNumber);

  // NOTE: При новом открытии окна, установить стейт на первоночальное состояние
  useEffect(() => {
    if (props.visible) {
      setCurrentNumber(props.currentOrganizationNumber);
    }
    // NOTE: Регировать только на props.visible
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  if (props.list.length === 0) {
    return null;
  }

  return (
    <Modal
      show={props.visible}
      onClose={props.onClose}
      variant={props.isMobileView ? 'full-screen' : 'simple'}
    >
      <ModalHeader title={t('header.main.b2b-user-menu.select-organization')} />
      <ModalContent>
        <List
          model={props.list}
          currentOrganizationNumber={currentNumber}
          onChangeSelected={setCurrentNumber}
        />
      </ModalContent>
      <ModalFooter>
        <RegularButton
          size="l"
          variant="primary"
          className={WideButtonClassName}
          onClick={() => props.onApplyClick(currentNumber)}
        >
          {t('header.main.b2b-user-menu.apply-button')}
        </RegularButton>
      </ModalFooter>
    </Modal>
  );
};
